var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, action, makeObservable } from 'mobx';
import { custom, disgardOldValue, object, withDefault } from '../../../utils/serializr/serializr';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { list } from '../../../utils/serializr/schema/list';
import { MemorizePointsWordTask } from '../MemorizePointsWordTask/MemorizePointsWordTask';
import { legacy } from '../../../utils/serializr/schema/outer/legacy';
import { primitive } from '../../../utils/serializr/schema/inner/primitive';
import { editable } from '../../../utils/mobx/decorators/editable';
import { MemorizePointsLegacy } from './MemorizePointsLegacy';
export class MemorizePointsStore {
    parent;
    wordTasks;
    isOrdered = true;
    manualHaveToKnow = 0;
    get memorizePointsLegacy() {
        return new MemorizePointsLegacy(this);
    }
    get questionTypeLegacy() {
        return this.memorizePointsLegacy;
    }
    constructor({ parent }) {
        makeObservable(this);
        this.parent = parent;
        for (let i = 1; i <= 15; i++) {
            Object.defineProperty(this, `point${i}`, {
                set: s => {
                    if (this.wordTasks.length >= i) {
                        this.wordTasks[i - 1].wordString = s;
                    }
                },
                get: () => {
                    if (this.wordTasks.length < i)
                        return '';
                    return this.wordTasks[i - 1].wordString;
                },
            });
            Object.defineProperty(this, `accuracy${i}`, {
                set: a => {
                    if (this.wordTasks.length >= i) {
                        this.wordTasks[i - 1].requiredAccuracy = a;
                    }
                },
                get: () => {
                    if (this.wordTasks.length < i)
                        return 100;
                    return this.wordTasks[i - 1].requiredAccuracy;
                },
            });
            Object.defineProperty(this, `prefix${i}`, {
                set: p => {
                    if (p.length === 0 || this.parent.wordTasks.length < i)
                        return;
                    this.parent.wordTasks[i - 1].ownAspect.prefix.aspectContent.local.primaryTextBasis = p;
                },
                get: () => {
                    if (this.parent.wordTasks.length < i)
                        return '';
                    if (!this.parent.wordTasks[i - 1].ownAspect.prefix.local.has.text)
                        return '';
                    return this.parent.wordTasks[i - 1].ownAspect.prefix.aspectContent.local.primaryTextBasis;
                },
            });
            Object.defineProperty(this, `postfix${i}`, {
                set: p => {
                    if (p.length === 0 || this.parent.wordTasks.length < i)
                        return;
                    this.parent.wordTasks[i - 1].ownAspect.postfix.aspectContent.local.primaryTextBasis = p;
                },
                get: () => {
                    if (this.parent.wordTasks.length < i)
                        return '';
                    if (!this.parent.wordTasks[i - 1].ownAspect.postfix.local.has.text)
                        return '';
                    return this.parent.wordTasks[i - 1].ownAspect.postfix.aspectContent.local.primaryTextBasis;
                },
            });
        }
    }
    get question() {
        return this.parent;
    }
    get ordered() {
        return this.isOrdered ? 1 : 0;
    }
    set ordered(o) {
        this.isOrdered = !!o;
    }
    get fontsize() {
        return this.memorizePointsLegacy.legacyFontSize;
    }
    set fontsize(f) {
        this.memorizePointsLegacy.legacyFontSize = f;
    }
    get manualSend() {
        return this.memorizePointsLegacy.legacyManualSend;
    }
    set manualSend(m) {
        this.memorizePointsLegacy.legacyManualSend = m;
    }
    get casesensitive() {
        if (this.wordTasks.length === 0)
            return 0;
        return this.wordTasks[0].isCaseSensitive ? 1 : 0;
    }
    set casesensitive(n) {
        this.wordTasks.forEach(wordTask => (wordTask.isCaseSensitive = !!n));
    }
    get numberOfOptions() {
        return this.wordTasks.length;
    }
    set numberOfOptions(n) {
        if (n < this.wordTasks.length) {
            this.wordTasks.replace(this.wordTasks.slice(0, n));
        }
        if (n > this.wordTasks.length) {
            for (let i = this.wordTasks.length; i < n; i++) {
                this.addWordTask();
            }
        }
        this.wordTasks.forEach(wordTask => (wordTask.isCaseSensitive = !!n));
    }
    get haveToKnow() {
        if (this.manualHaveToKnow) {
            return Math.min(this.manualHaveToKnow, this.wordTasks.length);
        }
        return this.wordTasks.length;
    }
    set haveToKnow(n) {
        if (n === this.wordTasks.length) {
            this.manualHaveToKnow = 0;
            return;
        }
        this.manualHaveToKnow = Math.min(n, this.wordTasks.length);
    }
    addWordTask() {
        const newWordTask = MemorizePointsWordTask.fromSerialized({ parent: this.question });
        this.wordTasks.push(newWordTask);
    }
    get legacyImages() {
        return undefined;
        return [];
    }
    set legacyImages(l) {
        if (!l)
            return;
        this.memorizePointsLegacy.legacyImages = l;
    }
    get legacyComments() {
        return undefined;
        return this.memorizePointsLegacy.legacyComments;
    }
    set legacyComments(l) {
        if (!l)
            return;
        this.memorizePointsLegacy.legacyComments = l;
    }
    static get serializeInfo() {
        const serializeInfo = {
            props: {
                wordTasks: withDefault(list(object(MemorizePointsWordTask, { parentDepth: 2 })), [{}, {}]),
                numberOfOptions: true,
                ordered: true,
                fontsize: true,
                manualSend: true,
                casesensitive: true,
                haveToKnow: true,
                legacyImages: legacy(disgardOldValue(custom(a => a, a => a))),
                legacyComments: legacy(disgardOldValue(custom(a => a, a => a))),
            },
        };
        for (let i = 1; i <= 15; i++) {
            serializeInfo.props[`point${i}`] = legacy(primitive);
            serializeInfo.props[`accuracy${i}`] = legacy(primitive);
            serializeInfo.props[`prefix${i}`] = legacy(primitive);
            serializeInfo.props[`postfix${i}`] = legacy(primitive);
        }
        return serializeInfo;
    }
}
__decorate([
    observable.ref
], MemorizePointsStore.prototype, "parent", void 0);
__decorate([
    editable('shallow')
], MemorizePointsStore.prototype, "wordTasks", void 0);
__decorate([
    editable()
], MemorizePointsStore.prototype, "isOrdered", void 0);
__decorate([
    editable()
], MemorizePointsStore.prototype, "manualHaveToKnow", void 0);
__decorate([
    memoize
], MemorizePointsStore.prototype, "memorizePointsLegacy", null);
__decorate([
    action.bound
], MemorizePointsStore.prototype, "addWordTask", null);
__decorate([
    computed
], MemorizePointsStore.prototype, "legacyImages", null);
__decorate([
    computed
], MemorizePointsStore.prototype, "legacyComments", null);
__decorate([
    memoize
], MemorizePointsStore, "serializeInfo", null);
